import { AlertDialogCore } from "../alert-dialog/core.js";
//#region src/core/ui/error-dialog/core.ts
/** Error-dialog core: an alert dialog whose open state is driven by media error state. */
var ErrorDialogCore = class extends AlertDialogCore {
	setProps() {}
};
//#endregion
export { ErrorDialogCore };

//# sourceMappingURL=core.js.map